<template>
  <page :manualInit="updateStatusState.init" :manualErr="updateStatusState.initErr" @reload="doInit">
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('motorClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('travelClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('fireClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <!-- <v-flex lg2 md3 xs6 v-if="checkAccess(['paClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('paClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex> -->
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('cargoClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('maidClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageClaimUpdateStatus'])">
            <v-card :class="isMatchRoute('packageClaimUpdateStatus') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageClaimUpdateStatus' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import { appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'claimUpdateStatus') {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    updateStatusState() {
      return this.$store.state.claims.updateStatus
    },
    renderAppType() {
      if (this.isMatchRouteExact('claimUpdateStatus') ||
        this.isMatchRouteExact('motorClaimUpdateStatus') ||
        this.isMatchRouteExact('travelClaimUpdateStatus') ||
        this.isMatchRouteExact('fireClaimUpdateStatus') ||
        this.isMatchRouteExact('maidClaimUpdateStatus') ||
        this.isMatchRouteExact('cargoClaimUpdateStatus') ||
        this.isMatchRouteExact('packageClaimUpdateStatus')) {
        return true
      } else {
        return false
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimUpdateStatusInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
